import React from "react";
import { Box, Paper } from "@mui/material";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export default function StatsRadarChart(props) {
  const { labels, data, name,otherPlayerdata,nameotherplayer } = props;

  return (
    <Box mt={2} mb={2}>
      <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5" }}>
        <Box sx={{ maxWidth: "400px", maxHeight: "400px" }}>
          <Radar
            data={{
              labels: labels,
              datasets: [
                {
                  label: name,
                  data: data,
                  fill: true,
                  backgroundColor: "rgba(255,255,0,0.1)",
                  pointBackgroundColor: "Red",
                  borderColor: "Red",
                  borderWidth: 3,
                },
                {
                  label: nameotherplayer,
                  data: otherPlayerdata,
                  fill: true,
                  backgroundColor: "rgba(255,255,0,0.1)",
                  pointBackgroundColor: "Blue",
                  borderColor: "Blue",
                  borderWidth: 3,
                },
              ],
            }}
            options={{
              responsive: true,
              scales: {
                r: {
                  min: 0,
                  max: 100,
                  ticks: {
                    color: "#000",
                  },
                  angleLines: {
                    color: "#96baf2",
                    lineWidth: 2,
                  },
                  grid: {
                    color: "#96baf2",
                    lineWidth: 2,
                  },
                  pointLabels: {
                    color: "#000",
                  },
                },
              },
              plugins: {
                legend: {
                  onClick: null,
                  labels: {
                    color: "#000",
                    font: { size: 14 },
                  },
                },
                tooltip: {
                  callbacks: {
                    title: (context) => {
                      let title = "";
                      context.forEach((elem, i) => {
                        if (i + 1 === context.length) {
                          title += elem.label;
                        } else {
                          title += elem.label + ", ";
                        }
                      });
                      return title;
                    },
                  },
                },
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
}
